import React from "react";
import { Link } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';

function Footer() {
  return (
    <footer className="footer homefooter">

      <div className="container">

        <div className="row footer-top">

          {/* LEFT */}
          <div className="col-lg-4 col-md-6">
            <h5 className="footer-title">Kamdhenu Paints</h5>
            <p className="footer-text">
              Premium finishes engineered for durability, beauty, and performance.
            </p>
          </div>

          {/* QUICK LINKS */}
       

          {/* SOCIAL */}
          <div className="col-lg-4 col-md-12">
            <h5 className="footer-title">Connect With Us</h5>

            <ul className="social">
            <li className="facebook"><a href="https://www.facebook.com/KamdhenuPaint/" target="_blank"><FacebookIcon/></a></li> <li className="twitter"><a href="https://twitter.com/KamdhenuPaints" target="_blank"><TwitterIcon/></a></li> <li className="instagram"><a href="https://www.instagram.com/kamdhenu_paints/" target="_blank"><InstagramIcon/></a></li> <li className="linkedin"><a href="https://www.linkedin.com/company/kamdhenupaintsofficial" target="_blank"><LinkedInIcon/></a></li> <li className="youtube"><a href="https://www.youtube.com/channel/UClUYBJ0j-IG0-5STFS6Eohg" target="_blank"><YouTubeIcon/></a></li>
            </ul>
          </div>

        </div>

        {/* BOTTOM */}
        <div className="footer-bottom row">
          <div className="col-md-6">
            <p>
              © 2026. All Rights Reserved |
              <Link to="/privacy-policy"> Privacy Policy</Link> |
              <Link to="/terms-and-conditions"> Terms & Conditions</Link>
            </p>
          </div>

          <div className="col-md-6 text-md-end">
            <p>
              Developed by{" "}
              <span
                className="developer-link"
                onClick={() => window.open('https://dialerp.com/', '_blank')}
              >
                DialERP Technologies Limited
              </span>
            </p>
          </div>
        </div>

      </div>

    </footer>
  );
}

export default Footer;